import React from "react";
import Work from "../components/ Work";
import Articles from "../components/Articles";
import Hero from "../components/Hero";
import Projects from "../components/Projects";

const HomePage = () => {
  return (
    <>
      <Hero />
      <Work />
      <Articles />
      <Projects />
    </>
  );
};

export default HomePage;
